import React from "react";
import axios from "@/utils/myAxios";
import Cookie from "js-cookie";
import moment from "moment";
import { walletTypeList } from "@/utils/constant";
import { Link } from "react-router-dom";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/1337.css";
import { RSA } from "@/utils/rsa";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    Pagination,
    message,
    Input,
    Select,
    Tooltip,
    Tag,
    Card,
    Modal,
    Form,
    Switch,
    Row,
    InputNumber,
    Spin,
    Statistic,
    Dropdown,
    Menu,
    Icon,
    Radio,
    Descriptions,
} from "antd";

// 表单数据
const formData = {
    vendor_id: undefined,
    kpoker_account: undefined,
    currency_code: undefined,
    wallet_type: 1,
    prop_cost_point_rate: undefined,
    avail_fee_rate: undefined,
    avail_ins_rate: undefined,
    avail_cowboy_rate: undefined,
    ins_mod: undefined,
    cowboy_mod: undefined,
    win: undefined,
    lose: undefined,
    white_list: undefined,
    callback_url: undefined,
    new_passwd: undefined,
};

export default class ProxyList extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        detailType: undefined, // 详情弹窗类型
        title: undefined, // 弹窗标题
        detailTitle: undefined, // 详情弹窗标题
        show: false, // 是否显示弹窗
        showDetail: false, // 是否显示详情弹窗
        loading: false, // 是否加载中
        detailLoading: false, // 详情是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            search_value: undefined,
        },
        formData: { ...formData }, // 表单数据
        data: [], // 表格数据
        dataInfo: {}, // 数据信息
        proxyData: {}, // 代理资料
        accessConfig: [], // 接入配置资料
        gameCurrencyTypeList: [], // 游戏币类型列表
        selectedData: {}, // 选中的表格数据
        walletTypeList: walletTypeList, // 钱包类型
    };

    componentDidMount () {
        this.fetchData();
        this.fetchGameCurrencyTypeList();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/vendor_list", {
                params: {
                    ...this.state.queryParams,
                    search_type: this.state.queryParams.search_value
                        ? "vendor_id"
                        : undefined,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: {
                        ...this.state.queryParams,
                        total: res.count || 0,
                    },
                    data: res.data || [],
                    dataInfo: res || {},
                });
            });
    };

    /**
     * 获取接入配置资料数据
     */
    fetchAccessConfig = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/kpoker_union/vendor_list", {
                params: {
                    page: 1,
                    limit: 100000000,
                },
            })
            .then((res) => {
                let accessConfig = [];
                res.data = res.data || [];
                res.data.forEach((item) => {
                    if (item.vendor_system_conf && item.vendor_system_conf.client_id) {
                        accessConfig.push({
                            agentID: item.vendor_system_conf.vendor_id,
                            systemCode: item.vendor_system_conf.system_code,
                            DesKey: item.vendor_system_conf.des_key,
                            DesIv: item.vendor_system_conf.des_iv,
                            ClientId: item.vendor_system_conf.client_id,
                            ClientSecret: item.vendor_system_conf.client_secret,
                        });
                    }
                });
                this.setState({
                    detailLoading: false,
                    accessConfig: accessConfig,
                });
            });
    };

    /**
     * 获取游戏币类型列表
     */
    fetchGameCurrencyTypeList = () => {
        axios.get("/v1/api/coin/current_effect_rate").then((res) => {
            this.setState({
                gameCurrencyTypeList: res.data || [],
            });
        });
    };

    /**
     * 设置是否能创建牌局
     */
    handleSetAllowCreate = (club_id, value) => {
        axios
            .patch("/v1/api/union_club_allow_create", {
                id: club_id,
                allow: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["setSuccessMessage"]);
                    this.fetchData();
                }
            });
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === "createClub") {
                    // 创建代理俱乐部
                    axios
                        .post(`/v1/api/kpoker_union/add_vendor`, {
                            vendor_id: values.vendor_id,
                            club_name: values.vendor_id,
                            kpoker_account: values.kpoker_account,
                            currency_code: values.currency_code,
                            wallet_type: values.wallet_type,
                            prop_cost_point_rate: Number(values.prop_cost_point_rate || 0),
                            avail_fee_rate: Number(values.avail_fee_rate || 0),
                            avail_ins_rate: Number(values.avail_ins_rate || 0),
                            avail_cowboy_rate: Number(values.avail_cowboy_rate || 0),
                            ins_mod: Number(values.ins_mod || 1),
                            cowboy_mod: Number(values.cowboy_mod || 1),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["createSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                                Modal.success({
                                    title: this.props.language["pleaseSaveAccountPassword"],
                                    content: (
                                        <div>
                                            <p>
                                                {this.props.language["account"]}：
                                                <b>{res.data.account}</b>
                                            </p>
                                            <p>
                                                {this.props.language["password"]}：
                                                <b>{res.data.password}</b>
                                            </p>
                                        </div>
                                    ),
                                    okText: this.props.language["copyAndSave"],
                                    onOk: () => {
                                        this.handleCopy(
                                            `${this.props.language["account"]}：${res.data.account}\n${this.props.language["password"]}：${res.data.password}`,
                                            this.props.language["proxyAccountPassword"]
                                        );
                                    },
                                });
                            }
                        });
                } else if (this.state.type === "editProportion") {
                    // 编辑分成
                    axios
                        .patch(`/v1/api/kpoker_union/edit_vendor`, {
                            club_id: Number(this.state.formData.club_id),
                            wallet_type: values.wallet_type,
                            prop_cost_point_rate: Number(values.prop_cost_point_rate || 0),
                            avail_fee_rate: Number(values.avail_fee_rate || 0),
                            avail_ins_rate: Number(values.avail_ins_rate || 0),
                            avail_cowboy_rate: Number(values.avail_cowboy_rate || 0),
                            ins_mod: Number(values.ins_mod || 1),
                            cowboy_mod: Number(values.cowboy_mod || 1),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["editSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "editWhiteIpList") {
                    // 编辑ip白名单
                    axios
                        .post(`/v1/api/kpoker_union/set_ip_white_list`, {
                            white_list: values.white_list,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["editSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "editProxyWhiteIpList") {
                    // 编辑代理ip白名单
                    axios
                        .patch(`/v1/api/kpoker_union/set_vendor_ip_white_list`, {
                            vendor_id: this.state.proxyData.vendor_id,
                            white_list: values.white_list,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["editSuccessMessage"]);
                                this.setState({
                                    proxyData: {
                                        ...this.state.proxyData,
                                        white_ips: values.white_list,
                                    },
                                });
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "editCallbackAddress") {
                    // 编辑回调地址
                    axios
                        .patch(`/v1/api/kpoker_union/set_vendor_callback_url`, {
                            vendor_id: this.state.proxyData.vendor_id,
                            callback_url: values.callback_url,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["editSuccessMessage"]);
                                this.setState({
                                    proxyData: {
                                        ...this.state.proxyData,
                                        callback_url: values.callback_url,
                                    },
                                });
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "editPassword") {
                    // 编辑密码
                    Modal.confirm({
                        title: this.props.language["hint"],
                        content: this.props.language["editConfirm"],
                        onOk: () => {
                            axios.get("/v1/api/kpoker_union/time").then((res) => {
                                if (res.code === 1) {
                                    axios
                                        .patch(`/v1/api/kpoker_union/set_vendor_new_password`, {
                                            vendor_id: this.state.proxyData.vendor_id,
                                            new_passwd: RSA.encrypt(
                                                values.new_passwd + "\b" + res.data
                                            ),
                                        })
                                        .then((res) => {
                                            if (res.code === 1) {
                                                this.setState({
                                                    proxyData: {
                                                        ...this.state.proxyData,
                                                        init_pass_changed: true,
                                                    },
                                                });
                                                this.handleClose();
                                                this.fetchData();

                                                Modal.success({
                                                    title:
                                                        this.props.language["pleaseSaveAccountPassword"],
                                                    content: (
                                                        <div>
                                                            <p>
                                                                {this.props.language["account"]}：
                                                                <b>{this.state.proxyData.kpoker_account}</b>
                                                            </p>
                                                            <p>
                                                                {this.props.language["newPassword"]}：
                                                                <b>{values.new_passwd}</b>
                                                            </p>
                                                        </div>
                                                    ),
                                                    okText: this.props.language["copyAndSave"],
                                                    onOk: () => {
                                                        this.handleCopy(
                                                            `${this.props.language["account"]}：${this.state.proxyData.kpoker_account}\n${this.props.language["password"]}：${values.new_passwd}`,
                                                            this.props.language["proxyAccountPassword"]
                                                        );
                                                    },
                                                });
                                            }
                                        });
                                }
                            });
                        },
                    });
                } else if (
                    this.state.type === "sendIntegral" ||
                    this.state.type === "recycleIntegral"
                ) {
                    // 发放、回收积分
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendIntegral"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.selectedData.club_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "editContribution") {
                    // 编辑服务费贡献比例设置
                    axios
                        .patch("/v1/api/union_modify_club_rebate", {
                            win: Number(values.win),
                            lose: Number(values.lose),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                }
            }
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item = {}) => {
        let title;
        switch (type) {
            case "createClub":
                title = this.props.language["createProxy"];
                break;
            case "proxyData":
                title = this.props.language["proxyInformation"];
                break;
            case "accessConfig":
                title = this.props.language["accessConfig"];
                break;
            case "sendIntegral":
                title = this.props.language["sendIntegral"];
                break;
            case "recycleIntegral":
                title = this.props.language["recycleIntegral"];
                break;
            case "editProportion":
                title = this.props.language["editProportion"];
                break;
            case "editWhiteIpList":
                title = this.props.language["editWhitelist"];
                break;
            case "editProxyWhiteIpList":
                title = this.props.language["editWhitelist"];
                break;
            case "editCallbackAddress":
                title = this.props.language["editCallbackAddress"];
                break;
            case "editPassword":
                title = this.props.language["editPassword"];
                break;
            case "editContribution":
                title = this.props.language["unionServiceContributionProportion"];
                break;
        }
        if (type === "proxyData") {
            this.setState(
                {
                    showDetail: true,
                    detailType: type,
                    detailTitle: title,
                    proxyData: item.vendor_system_conf || {},
                },
                () => { }
            );
        } else if (type === "accessConfig") {
            this.setState(
                {
                    showDetail: true,
                    detailType: type,
                    detailTitle: title,
                    accessConfig: [],
                },
                () => {
                    this.fetchAccessConfig();
                }
            );
        } else if (type === "editContribution") {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    win: this.state.dataInfo.positive_profit_prop,
                    lose: this.state.dataInfo.negative_profit_prop,
                },
            });
        } else if (type === "editProportion") {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    club_id: item.club_id,
                    wallet_type: item.vendor_system_conf.wallet_type,
                    prop_cost_point_rate: item.club_prop_cost_point_rate,
                    avail_fee_rate: item.club_avail_fee_rate,
                    avail_ins_rate: item.club_avail_ins_rate,
                    avail_cowboy_rate: item.club_avail_cowboy_rate,
                    ins_mod: item.club_ins_mod || undefined,
                    cowboy_mod: item.club_cowboy_mod || undefined,
                },
            });
        } else if (type === "editWhiteIpList") {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    white_list: this.state.dataInfo.white_ips || undefined,
                },
            });
        } else if (type === "editProxyWhiteIpList") {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    white_list: this.state.proxyData.white_ips || undefined,
                },
            });
        } else if (type === "editCallbackAddress") {
            this.setState({
                show: true,
                type,
                title,
                formData: {
                    callback_url: this.state.proxyData.callback_url || undefined,
                },
            });
        } else if (type === "editPassword") {
            this.setState({
                show: true,
                type,
                title,
            });
        } else {
            this.setState({
                show: true,
                type,
                title,
                selectedData: { ...item },
            });
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false, formData: { ...formData } });
    };

    /**
     * 关闭详情弹窗
     */
    handleCloseDetail = () => {
        this.setState({ showDetail: false, detailType: undefined });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 复制并保存到本地
     */
    handleCopy = (content, title) => {
        // 复制
        const textarea = document.createElement("textarea");
        textarea.value = content;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        message.success(this.props.language["saveSuccessMessage"]);

        // 保存
        const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${title}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    search_value: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["proxyIdPlaceholder"]}
                        value={this.state.queryParams.search_value}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("search_value", e.target.value)
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow("createClub")}
                    >
                        {this.props.language["createProxy"]}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow("accessConfig")}
                    >
                        {this.props.language["accessConfig"]}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow("editWhiteIpList")}
                    >
                        {this.props.language["ipWhitelist"]}
                    </Button>
                    <Button
                        type="link"
                        onClick={() =>
                            window.open(process.env.REACT_APP_ACCESS_DOCUMENT_ADDRESS)
                        }
                    >
                        {this.props.language["onlineAccessDocument"]}
                    </Button>
                </div>

                {/* 概况 */}
                <Row type="flex" className="m10 mb0">
                    {/* 柜台积分 */}
                    <div className="number-box-list">
                        <p>{this.props.language["counterPoint"]}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic value={Number(this.state.dataInfo.point || 0)} />
                            </div>
                        </div>
                    </div>

                    {/* 柜台钻石 */}
                    {/* <div className="number-box-list">
                        <p>{this.props.language['counterDiamond']}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.diamond || 0
                                    )}
                                />
                            </div>
                        </div>
                    </div> */}

                    {/* 可用占比 */}
                    <div className="number-box-list">
                        <p>{this.props.language["availableProportion"]}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.avail_fee_rate || 0)}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["serviceFee"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.avail_ins_rate || 0)}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["insurance"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.avail_cowboy_rate || 0)}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["cowboy"]}</p>
                            </div>
                        </div>
                    </div>

                    {/* 上级超盟服务费贡献比例 */}
                    <div className="number-box-list">
                        <p>
                            {this.props.language["superUnionServiceContributionProportion"]}
                        </p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.super_positive_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["winner"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.super_negative_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["underdog"]}</p>
                            </div>
                        </div>
                    </div>

                    {/* 本联盟服务费贡献比例 */}
                    {/* <div className="number-box-list">
                        <div>
                            <p>{this.props.language["unionServiceContributionProportion"]}</p>
                            <Button className="btn" shape="circle" icon="edit" onClick={() => this.handleShow('editContribution')}></Button>
                        </div>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.positive_profit_prop || 0)}
                                    suffix="%"
                                    valueStyle={{ color: '#ffffffff' }}
                                />
                                <p className="label">{this.props.language["winner"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.negative_profit_prop || 0)}
                                    suffix="%"
                                    valueStyle={{ color: '#ffffffff' }}
                                />
                                <p className="label">{this.props.language["underdog"]}</p>
                            </div>
                        </div>
                    </div> */}
                </Row>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? "small" : "",
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ""}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyAccount"]}
                            dataIndex="kpoker_account"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyPlatformTokenType"]}
                            dataIndex="currency_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["walletType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.walletTypeList.find(
                                    (item2) => item2.value === item.vendor_system_conf.wallet_type
                                )
                                    ? this.state.walletTypeList.find(
                                        (item2) =>
                                            item2.value === item.vendor_system_conf.wallet_type
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["palyerNumber"]}
                            dataIndex="club_member_cnt"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterPoint"]}
                            dataIndex="point"
                        />
                        {Cookie.get("isNonApiChannel") !== "true" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeProportion"]}
                                dataIndex=""
                                render={(item) => `${item.club_prop_cost_point_rate}%`}
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_fee_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_ins_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_cowboy_rate}%`}
                        />
                        {/* <Table.Column
                            align="center"
                            title={this.props.language['insuranceDivide']}
                            dataIndex=""
                            render={(item) =>
                                item.club_ins_mod === 1
                                    ? this.props.language["traditionMode"]
                                    : this.props.language["evMode"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language['cowboyDivide']}
                            dataIndex=""
                            render={(item) =>
                                item.club_cowboy_mod === 1
                                    ? this.props.language["traditionMode"]
                                    : this.props.language["evMode"]
                            }
                        /> */}
                        {/* <Table.Column
                            align="center"
                            title={this.props.language["allowCreateTable"]}
                             dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            dataIndex=""
                            render={(item) => {
                                return (
                                    <Switch
                                        checked={item.allow_create === 1}
                                        onChange={(value) =>
                                            this.handleSetAllowCreate(item.club_id, value)
                                        }
                                    />
                                );
                            }}
                        /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={220}
                            render={(item) => (
                                <>
                                    <Button
                                        type="default"
                                        onClick={() => this.handleShow("proxyData", item)}
                                    >
                                        {this.props.language["proxyInformation"]}
                                    </Button>
                                    <Dropdown
                                        trigger={["click"]}
                                        className="ml10"
                                        overlay={
                                            <Menu onClick={({ key }) => this.handleShow(key, item)}>
                                                <Menu.Item key="sendIntegral">
                                                    {this.props.language["sendIntegral"]}
                                                </Menu.Item>
                                                <Menu.Item key="recycleIntegral">
                                                    {this.props.language["recycleIntegral"]}
                                                </Menu.Item>
                                                <Menu.Item key="editProportion">
                                                    {this.props.language["editProportion"]}
                                                </Menu.Item>
                                            </Menu>
                                        }
                                    >
                                        <Button type="primary" ghost>
                                            {this.props.language["operation"]}
                                            <Icon type="down" />
                                        </Button>
                                    </Dropdown>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    gameCurrencyTypeList={this.state.gameCurrencyTypeList}
                    walletTypeList={this.state.walletTypeList}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 代理资料、接入配置弹窗 */}
                <DetailModal
                    {...this.props}
                    visible={this.state.showDetail}
                    title={this.state.detailTitle}
                    type={this.state.detailType}
                    loading={this.state.detailLoading}
                    proxyData={this.state.proxyData}
                    accessConfig={this.state.accessConfig}
                    handleShow={this.handleShow}
                    handleCopy={this.handleCopy}
                    onCancel={this.handleCloseDetail}
                />
            </div>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 创建代理 */}
                            {this.props.type === "createClub" && (
                                <>
                                    <Form.Item
                                        label={`${this.props.language["proxyId"]} ${this.props.language["proxyIdSuffix"]}`}
                                    >
                                        {getFieldDecorator("vendor_id", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["proxyIdVerify"],
                                                },
                                                {
                                                    pattern: /^.{3,64}$/,
                                                    message: this.props.language["proxyIdVerify1"],
                                                    trigger: "blur",
                                                },
                                            ],
                                            initialValue: this.props.formData.vendor_id,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={this.props.language["proxyIdPlaceholder"]}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["proxyAccount"]}>
                                        {getFieldDecorator("kpoker_account", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["proxyAccountVerify"],
                                                },
                                                {
                                                    pattern: /^[A-Za-z0-9]{4,16}$/,
                                                    message: this.props.language["proxyAccountVerify1"],
                                                    trigger: "blur",
                                                },
                                            ],
                                            initialValue: this.props.formData.kpoker_account,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language["proxyAccountPlaceholder"]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        label={this.props.language["proxyPlatformTokenType"]}
                                    >
                                        {getFieldDecorator("currency_code", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["proxyPlatformTokenTypeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.currency_code,
                                        })(
                                            <Select
                                                allowClear
                                                showSearch
                                                optionFilterProp="children"
                                                placeholder={
                                                    this.props.language[
                                                    "proxyPlatformTokenTypePlaceholder"
                                                    ]
                                                }
                                            >
                                                {this.props.gameCurrencyTypeList.map((item, index) => (
                                                    <Select.Option value={item.currency_code} key={index}>
                                                        {item.currency_name}
                                                        {Cookie.get("isAce1") !== "true" && (
                                                            <span>
                                                                （1:{item.currency_rate}:{item.usdt_rate}）
                                                            </span>
                                                        )}
                                                        {Cookie.get("isAce1") === "true" && (
                                                            <span>（{item.currency_rate}:1）</span>
                                                        )}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["walletType"]}>
                                        {getFieldDecorator("wallet_type", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["walletTypeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.wallet_type,
                                        })(
                                            <Radio.Group disabled={this.props.type === "edit"}>
                                                {this.props.walletTypeList.map((item, index) => (
                                                    <Radio key={index} value={item.value}>
                                                        {item.label}
                                                    </Radio>
                                                ))}
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    {Cookie.get("isNonApiChannel") !== "true" && (
                                        <Form.Item
                                            label={this.props.language["propCusomeProportion"]}
                                        >
                                            {getFieldDecorator("prop_cost_point_rate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language["propCusomeProportionVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.prop_cost_point_rate,
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={0}
                                                    placeholder={
                                                        this.props.language[
                                                        "propCusomeProportionPlaceholder"
                                                        ]
                                                    }
                                                    formatter={(value) => `${value}%`}
                                                />
                                            )}
                                        </Form.Item>
                                    )}
                                    <Form.Item label={this.props.language["serviceProportion"]}>
                                        {getFieldDecorator("avail_fee_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["serviceProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={2}
                                                placeholder={
                                                    this.props.language["serviceProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["insuranceProportion"]}>
                                        {getFieldDecorator("avail_ins_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["insuranceProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={2}
                                                placeholder={
                                                    this.props.language["insuranceProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyProportion"]}>
                                        {getFieldDecorator("avail_cowboy_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["cowboyProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_cowboy_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={2}
                                                placeholder={
                                                    this.props.language["cowboyProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    {/* <Form.Item label="保险分成">
                                        {getFieldDecorator("ins_mod", {
                                            rules: [{ required: true, message: this.props.language["insuranceDivideVerify"] }],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["traditionMode"]}</Radio>
                                                <Radio value={2}>{this.props.language["evMode"]}</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyDivide"]}>
                                        {getFieldDecorator("cowboy_mod", {
                                            rules: [{ required: true, message: this.props.language["cowboyDivideVerify"] }],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["traditionMode"]}</Radio>
                                                <Radio value={2}>{this.props.language["evMode"]}</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item> */}
                                </>
                            )}

                            {/* 编辑分成 */}
                            {this.props.type === "editProportion" && (
                                <>
                                    {Cookie.get("isNonApiChannel") !== "true" && (
                                        <Form.Item
                                            label={this.props.language["propCusomeProportion"]}
                                        >
                                            {getFieldDecorator("prop_cost_point_rate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language["propCusomeProportionVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.prop_cost_point_rate,
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={0}
                                                    placeholder={
                                                        this.props.language[
                                                        "propCusomeProportionPlaceholder"
                                                        ]
                                                    }
                                                    formatter={(value) => `${value}%`}
                                                />
                                            )}
                                        </Form.Item>
                                    )}
                                    <Form.Item label={this.props.language["serviceProportion"]}>
                                        {getFieldDecorator("avail_fee_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["serviceProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_fee_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={2}
                                                placeholder={
                                                    this.props.language["serviceProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["insuranceProportion"]}>
                                        {getFieldDecorator("avail_ins_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["insuranceProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_ins_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={2}
                                                placeholder={
                                                    this.props.language["insuranceProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyProportion"]}>
                                        {getFieldDecorator("avail_cowboy_rate", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["cowboyProportionVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.avail_cowboy_rate,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={2}
                                                placeholder={
                                                    this.props.language["cowboyProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    {/* <Form.Item label="保险分成">
                                        {getFieldDecorator("ins_mod", {
                                            rules: [{ required: true, message: this.props.language["insuranceDivideVerify"] }],
                                            initialValue: this.props.formData.ins_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["traditionMode"]}</Radio>
                                                <Radio value={2}>{this.props.language["evMode"]}</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["cowboyDivide"]}>
                                        {getFieldDecorator("cowboy_mod", {
                                            rules: [{ required: true, message: this.props.language["cowboyDivideVerify"] }],
                                            initialValue: this.props.formData.cowboy_mod,
                                        })(
                                            <Radio.Group>
                                                <Radio value={1}>{this.props.language["traditionMode"]}</Radio>
                                                <Radio value={2}>{this.props.language["evMode"]}</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item> */}
                                </>
                            )}

                            {/* 编辑ip白名单 */}
                            {this.props.type === "editWhiteIpList" && (
                                <>
                                    <Form.Item
                                        label={`${this.props.language["ipWhitelist"]}${this.props.language["ipWhitelistFix"]}`}
                                    >
                                        {getFieldDecorator("white_list", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: this.props.language["ipWhitelistVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.white_list,
                                        })(
                                            <Input.TextArea
                                                rows={5}
                                                maxLength={120}
                                                allowClear
                                                placeholder={
                                                    this.props.language["ipWhitelistPlaceholder"]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 编辑代理ip白名单 */}
                            {this.props.type === "editProxyWhiteIpList" && (
                                <>
                                    <Form.Item
                                        label={`${this.props.language["ipWhitelist"]}${this.props.language["ipWhitelistFix"]}`}
                                    >
                                        {getFieldDecorator("white_list", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: this.props.language["ipWhitelistVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.white_list,
                                        })(
                                            <Input.TextArea
                                                rows={5}
                                                maxLength={120}
                                                allowClear
                                                placeholder={
                                                    this.props.language["ipWhitelistPlaceholder"]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 编辑回调地址 */}
                            {this.props.type === "editCallbackAddress" && (
                                <>
                                    <Form.Item
                                        label={`${this.props.language["callbackAddress"]}`}
                                    >
                                        {getFieldDecorator("callback_url", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["callbackAddressVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.callback_url,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language["callbackAddressPlaceholder"]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 编辑密码 */}
                            {this.props.type === "editPassword" && (
                                <>
                                    <Form.Item label={`${this.props.language["newPassword"]}`}>
                                        {getFieldDecorator("new_passwd", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["newPasswordVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.new_passwd,
                                        })(
                                            <Input
                                                maxLength={60}
                                                allowClear
                                                placeholder={
                                                    this.props.language["newPasswordPlaceholder"]
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}

                            {/* 发放回收积分 */}
                            {(this.props.type == "sendIntegral" ||
                                this.props.type == "recycleIntegral") && (
                                    <>
                                        <Form.Item label={this.props.language["amount"]}>
                                            {getFieldDecorator("amount", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["amountVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.amount,
                                            })(
                                                <InputNumber
                                                    min={0.01}
                                                    max={100000000}
                                                    precision={2}
                                                    placeholder={this.props.language["amountPlaceholder"]}
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                            {/* 编辑本联盟服务费贡献比例 */}
                            {this.props.type === "editContribution" && (
                                <>
                                    <Form.Item label={this.props.language["winnerProportion"]}>
                                        {getFieldDecorator("win", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["winnerProportionPlaceholder"],
                                                },
                                            ],
                                            initialValue: this.props.formData.win,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["winnerProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["loserProportion"]}>
                                        {getFieldDecorator("lose", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["loserProportionPlaceholder"],
                                                },
                                            ],
                                            initialValue: this.props.formData.lose,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["loserProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 代理资料、接入配置弹窗
 */
class DetailModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={this.props.type === "accessConfig" ? 600 : 1200}
                title={
                    this.props.type === "accessConfig" ? (
                        <>
                            <span>{this.props.title}</span>
                            <span>
                                （{this.props.language["apiAddress"]}：
                                <Button
                                    className="fs16"
                                    type="link"
                                    onClick={() => window.open(process.env.REACT_APP_API_ADDRESS)}
                                >
                                    {process.env.REACT_APP_API_ADDRESS}
                                </Button>
                                ）
                            </span>
                        </>
                    ) : (
                        this.props.title
                    )
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: this.props.type === "accessConfig" ? 0 : 24,
                }}
                footer={
                    this.props.type === "accessConfig" ? (
                        <Button
                            type="primary"
                            onClick={() =>
                                this.props.handleCopy(
                                    JSON.stringify(this.props.accessConfig, null, 4),
                                    this.props.title
                                )
                            }
                        >
                            {this.props.language["copyAndSave"]}
                        </Button>
                    ) : null
                }
            >
                <Spin spinning={this.props.loading}>
                    {/* 代理资料 */}
                    {this.props.type === "proxyData" && (
                        <Descriptions size="small" column={1} bordered>
                            <Descriptions.Item
                                label={this.props.language["proxySystemAddress"]}
                            >
                                {Cookie.get("isAce1") === "true" ? (
                                    <Button
                                        type="link"
                                        onClick={() =>
                                            window.open(process.env.REACT_APP_ACE1_BACKGROUND_ADDRESS)
                                        }
                                    >
                                        {process.env.REACT_APP_ACE1_BACKGROUND_ADDRESS}
                                    </Button>
                                ) : (
                                    <Button
                                        type="link"
                                        onClick={() =>
                                            window.open(
                                                process.env.REACT_APP_KPOKER_BACKGROUND_ADDRESS
                                            )
                                        }
                                    >
                                        {process.env.REACT_APP_KPOKER_BACKGROUND_ADDRESS}
                                    </Button>
                                )}
                            </Descriptions.Item>
                            <Descriptions.Item label={this.props.language["proxyAccount"]}>
                                {this.props.proxyData.kpoker_account}
                            </Descriptions.Item>
                            <Descriptions.Item label={this.props.language["initPassword"]}>
                                <Row type="flex" align="middle" justify="space-between">
                                    <span>
                                        {this.props.proxyData.init_pass_changed
                                            ? this.props.language["initPasswordTips"]
                                            : this.props.proxyData.init_pass}
                                    </span>
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() => this.props.handleShow("editPassword")}
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                </Row>
                            </Descriptions.Item>
                            <Descriptions.Item label={this.props.language["systemCode"]}>
                                {this.props.proxyData.system_code}
                            </Descriptions.Item>
                            <Descriptions.Item label="DesKey">
                                {this.props.proxyData.des_key}
                            </Descriptions.Item>
                            <Descriptions.Item label="DesIv">
                                {this.props.proxyData.des_iv}
                            </Descriptions.Item>
                            <Descriptions.Item label="ClientId">
                                {this.props.proxyData.client_id}
                            </Descriptions.Item>
                            <Descriptions.Item label="ClientSecret">
                                {this.props.proxyData.client_secret}
                            </Descriptions.Item>
                            <Descriptions.Item label={this.props.language["ipWhitelist"]}>
                                <Row type="flex" align="middle" justify="space-between">
                                    <span>{this.props.proxyData.white_ips}</span>
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() =>
                                            this.props.handleShow("editProxyWhiteIpList")
                                        }
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                </Row>
                            </Descriptions.Item>
                            <Descriptions.Item label={this.props.language["apiAddress"]}>
                                {this.props.proxyData.api_url}
                            </Descriptions.Item>
                            <Descriptions.Item label={this.props.language["callbackAddress"]}>
                                <Row type="flex" align="middle" justify="space-between">
                                    <span>{this.props.proxyData.callback_url}</span>
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() => this.props.handleShow("editCallbackAddress")}
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                </Row>
                            </Descriptions.Item>
                            <Descriptions.Item
                                label={this.props.language["gameServerIpAddress"]}
                            >
                                {this.props.proxyData.server_ips}
                            </Descriptions.Item>
                        </Descriptions>
                    )}

                    {/* 接入配置 */}
                    {this.props.type === "accessConfig" && (
                        <JSONPretty
                            id="json-pretty"
                            data={this.props.accessConfig}
                        ></JSONPretty>
                    )}
                </Spin>
            </Modal>
        );
    }
}
